import { KOLKATA_TIMEZONE_DIFFERENCE_IN_MILLISECONDS, ServerIntervals } from 'modules/TradingChart/consts';
import TradingChartService from 'modules/TradingChart/service';
import SearchService from 'modules/Search';
import FormatService from 'modules/Format';
import { Exchange } from 'modules/Search/constants';
import AbstractBarsProviderLive from './AbstractBarsProviderLive';
import {
  Bar,
  LibrarySymbolInfo,
  SubscribeBarsCallback,
} from '../../../../sources/charting_library.min';
import { SubscriptionOptions } from '../typings';

class BarsProviderLiveWeb extends AbstractBarsProviderLive {
  onResetCacheCallback!: () => void;

  public async subscribeToLiveBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    newDataCallback: SubscribeBarsCallback,
    ticker: string,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void,
  ) {
    const currentSymbol = FormatService.decodeCustomTvExchangeToken(
      ticker,
    );

    // GENERAL PART
    const interval = TradingChartService.getMappedIntervalValue(resolution);
    const exchangeToken = currentSymbol || '';

    const scripData =
      await SearchService.searchByExchangeToken(exchangeToken);

    // DESKTOP PART
    const subscriptionOptions: SubscriptionOptions = {
      guid: ticker,
      ticker: exchangeToken,
      interval: resolution,
      instrumentKey: scripData?.instrumentKey || '',
      listeners: {
        [listenerGuid]: newDataCallback,
      },
      onDataReceived(bar: Bar) {
        const updatedBar = { ...bar };

        // for day/week/month add IST time diff
        if (interval === ServerIntervals.ONE_DAY) {
          updatedBar.time += KOLKATA_TIMEZONE_DIFFERENCE_IN_MILLISECONDS;
        }

        Object.values(this.listeners).map(listener => listener(updatedBar));
      },
      exchange: symbolInfo.exchange as Exchange,
      onResetCacheNeededCallback,
    };

    TradingChartService.subscribe(subscriptionOptions);
  }

  unsubscribeFromLiveBars(guid: string, onNewDataListenerGuid: string) {
    TradingChartService.unsubscribe(guid, onNewDataListenerGuid);
  }
}

export default new BarsProviderLiveWeb();
